module.exports = __webpack_public_path__ + "img/logo_ads_full.ab3874c0.png";